import 'rc-progress/assets/index.css';
import React, {Component} from 'react';

import {Line} from 'rc-progress';
import './styles.scss'

class AutoProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percent: 0,
        };
        this.increase = this.increase.bind(this);
    }

    componentDidMount() {
        this.increase();
    }

    increase() {
        const {percent} = this.state;
        const newPercent = percent + 1;
        if (newPercent >= 100) {
            clearTimeout(this.tm);
            this.props.progress(true);
            return;
        }
        this.setState({percent: newPercent});
        this.tm = setTimeout(this.increase, 100);

    }


    render() {
        const {percent} = this.state;
        return (
            <div id="bar_container">
                <Line strokeWidth="5" percent={percent} strokeColor="#e7be04" strokeLinecap="butt"/>
            </div>
        );
    }
}

export default AutoProgressBar